export default __webpack_public_path__ + "static/media/facebook-icon-blue.535a7048.svg";